import { useState } from 'react';
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';


import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Toolbar,
    Frame,
  Window,
    
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';

const AboutPage = () => {

    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
            navigate(dir);
        };
    
  return (
    <ThemeProvider theme={rose}>
          <Window resizable className='window' style={{ display: 'block', height: '80vh', width: 'calc(90vh * (3/2))', maxWidth: "800px"}}>
          <WindowHeader className='window-title' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>Resume and Credits</span>
              <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => handleRedirect('/')}>
              <span style={{ fontWeight: 'bold', fontSize: '12px' }}>✕</span>
              </Button>
            </WindowHeader>

            <WindowContent style={{ height: 'calc(100% - 33px)', padding: 0 }}>
              <Frame variant='well' className='footer' style={{ height: '100%', margin: 0 }}>
                <ScrollView style={{ height: '100%' }}>
                  <div style={{ padding: '1rem' }}>
                  
                    <h2>Credits</h2>
                        <h4>Games</h4>
                      <ul style={{ color: "#c43961" }}>
          
                        <li>Untethered(2026): Producer, Lead Unity Engineer, C# Programmer, Narrative Lead, Level Designer, 3D Modeler</li>
          

                        <li><a href="https://glorgogame.com/">Glorgo's Microplastic Mine(2026): 3D Modeler, Animator</a></li>
                        <li><a href="https://openalphausc.weebly.com/spring2025.html">Open Your Browser(2025): Designer</a></li>
                        <li><a href="https://xaragame.itch.io/battle-of-the-heart">Battle of the Heart(2023): Producer, Lead Unity Engineer, C# Programmer, Narrative Lead</a></li>
                        <li><a href="https://xaragame.itch.io/dinosaur-game-twist">Dino Game Twist(2022): Solo Dev</a></li>
                      </ul>
          
                        <h4>Other Websites</h4>
                      <ul style={{ color: "#c43961" }}>
          
                        <li><a href="https://coachkenfitness.com/">Coachkenfitness.com, commissioned website of a personal trainer</a></li>
                      </ul>
                    

                    <h2>Work Experience</h2>
          
                      <h4>Sunrun: Retail Sales Associate</h4>
                      <p>October 2025 - December 2025</p>
                      <p>Description:</p>
                      <ul style={{ color: "#c43961" }}>
                        <li>Approached customers at Lowe’s to pitch them appointments to learn and purchase solar</li>
                        <li>Assisted customers with finding Items, navigating the store and hardware questions</li>
                        <li>Contacted potential leads to schedule appointments</li>
                        <li>Wrote detailed notes on what I learned about customers from our interactions</li>
                      </ul>
                      <p>References:</p>
                        <ul style={{ color: "#c43961" }}>
                        </ul>
              
                      <h4>we.shop.LIVE: Live Stream Operator</h4>
                      <p>July 2025 - October 2025</p>
                      <p>Description:</p>
                      <ul style={{ color: "#c43961" }}>
                        <li>Ran behind the scenes livestream production for TikTok live seling</li>
                        <li>Used software like TTLS, OBS, and Mixcraft for livestream production</li>
                        <li>Used excel for recording sales data</li>
                        <li>Used improvisation and people skils to help the host create a friendly
              environment conducive to sales</li>
                      </ul>
                      <p>References:</p>
                        <ul style={{ color: "#c43961" }}>
                          <li>Leo Chu: (805) 393-0558</li>
                        </ul>
              
                        <h4>Agape ABA Services: IT Specialist</h4>
                        <p>May 2024 - March 2025</p>
                        <p>Description:</p>
                        <ul style={{ color: "#c43961" }}>
                          <li>Instaled and configured operating systems and applications.</li>
                          <li>Responded to customer inquiries and provided technical assistance over
                          phone and in person.</li>
                          <li>Configured and tested new software and hardware.</li>
                        </ul>
                        <p>References:</p>
                          <ul style={{ color: "#c43961" }}>
                            <li>Cody Jacobs: (661) 436-0224</li>
                            <li>June Broom: (818) 634-5761</li>
                          </ul>
          
                    <h2>Volunteer and Club Work</h2>
                      <h4>Mid Valley YMCA: Food Distribution Volunteer</h4>
                      <p>July 2025 - Present</p>
                      <p>Description:</p>
                      <ul style={{ color: "#c43961" }}>
                        <li>Helping packaging groceries to distribute to families in need</li>
                        <li>Helping to clean up the materials we used for distributing groceries at the end</li>
                        <li>Loaded groceries into people's cars</li>
                      </ul>
                      <p>References:</p>
                        <ul style={{ color: "#c43961" }}>
                          <li>Cody Jacobs: (661) 436-0224</li>
                          <li>June Broom: (818) 634-5761</li>
                        </ul>
          
                      <h4>Granada Hills Charter Robodox: VEX Robotics Team Captain</h4>
                      <p>August 2020 - May 2023</p>
                      <p>Description:</p>
                      <ul style={{ color: "#c43961" }}>
                        <li>Helped Lead the VEX portion of the Granada Hills Charter High School Robotics team</li>
                        <li>Led development, design and programming of VEX Robotics </li>
                        <li>Programmed Robots with C++</li>
                        <li>Taught new members on the team how VEX Robotics worked</li>
                        <li>Helped write grants for the team's funding</li>
                        <li>Volunteered to teach LEGO Robotics to 3rd through 7th graders about block coding and LEGO Robotics every Friday for a year</li>
                      </ul>
                      <p>References:</p>
                        
                  </div>
                </ScrollView>
              </Frame>
            </WindowContent>
          </Window>
          
          
    </ThemeProvider>
  );
}

export default AboutPage;
